import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=74328ee9"
import script from "./payFail.vue?vue&type=script&lang=js"
export * from "./payFail.vue?vue&type=script&lang=js"
import style0 from "./payFail.vue?vue&type=style&index=0&id=74328ee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports